var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBadgePartiallyRefunded(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5293 4C7.29824 5.72449 5.8229 7.05469 4.03516 7.05469C2.24741 7.05469 0.772077 5.72449 0.541016 4H7.5293Z",
    fill: "#424242"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.04297,
    cy: 3.52734,
    r: 3.02734,
    stroke: "#424242",
    strokeDasharray: "0.5 0.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgePartiallyRefunded);
export default __webpack_public_path__ + "static/media/badgePartiallyRefunded.86f3f6242bf95917b8839c1bff310d7d.svg";
export { ForwardRef as ReactComponent };